import React from 'react'
import './skeleton-component.scss'

type SkeletonProps = {
  width?: string
  height?: string
  /** Rounded pill for short values; block for rows and cards. */
  shape?: 'text' | 'block'
  classes?: string[]
}

/**
 * Shimmering placeholder for a value that is still loading. Hidden from
 * screen readers; mark the loading region with `aria-busy` instead.
 */
export const Skeleton = ({
  width = '100%',
  height = '1em',
  shape = 'text',
  classes = [],
}: SkeletonProps) => (
  <span
    aria-hidden='true'
    data-testid='skeleton'
    className={['skeleton', `skeleton--${shape}`, ...classes].join(' ')}
    style={{ width, height }}
  />
)
